import React from 'react';
import PropTypes from 'prop-types';
import { ApplicationFormShell } from 'web-ui-components/lib/layout/shells';
import { PageHeading } from 'web-ui-components/lib/typography/headings';

export const CallPayment = (props) => {
  const { content } = props;
  return (
    <ApplicationFormShell>
      <div className="col-xs-8 text-center">
        <img
          alt="on the phone"
          src="../../../../images/bow/on-the-phone.svg"
        ></img>
        <PageHeading>{content.callPaymentTitle}</PageHeading>
        <p>
          <strong>{content.callUsNumber} </strong>
        </p>
        <p>
          <strong>{content.callPaymentText}</strong>
        </p>
      </div>
    </ApplicationFormShell>
  );
};

CallPayment.propTypes = {
  content: PropTypes.object,
};
